import React from 'react';
import { get } from 'lodash';
import APIClient from '../../services/APIClient';
import { allMenuItem } from '../../components/CommonTableColumns';
import { MenuItem } from '../../components/MenuItem/MenuItem';
import { INACTIVE_LABEL } from '../../../screens/AdminTools/components/Dictionary/components/DictionaryStatics';

class PlazaController {
  async getAll(params = { page_token: 0, page_size: 999 }, props = {}) {
    const { showHidden = false } = props;
    const response = await APIClient.get('/plazas', { params });
    const plazaList = get(response, 'data.payloads', []);

    if (showHidden) {
      return plazaList;
    }

    return plazaList.filter((plaza) => !plaza.hidden);
  }

  sortByName(data = []) {
    return data.sort((cur, next) => cur.name.localeCompare(next.name));
  }

  makeOptionsWithStatus(data = []) {
    return data.map(({ name, uuid, plazaStatus, customerId }) => {
      const conditionInactive = plazaStatus === 'INACTIVE' ? INACTIVE_LABEL : '';

      return { value: uuid, label: `${name} ${conditionInactive}`, customerId };
    });
  }

  makeMenuOptionsFromBasicOptions(data = []) {
    const children = [allMenuItem];

    data.forEach(({ value, label }) => {
      children.push(
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>,
      );
    });

    return children;
  }
}

export default new PlazaController();
